import React, { useEffect, useState } from 'react';
import { Box, HStack, Text, Input, Button, Select } from '@chakra-ui/react';
import { AdminUsersType } from '../Table/MaintenanceAdminUsersTable';
import { QueryAdminUsersApi } from '../../../../apis/QueryMaintenance.api';
import {
  AdminUsersSearchCondition,
  RoleEnum
} from '../../../../pages/AdminUsersMaintenance';
import { MaintenanceCompareEnum } from '../../../constants/MaintenanceConstants';
interface props {
  setMaintenanceDatas: React.Dispatch<
    React.SetStateAction<AdminUsersType[] | undefined>
  >;
  Query: AdminUsersSearchCondition;
  setQuery: React.Dispatch<React.SetStateAction<AdminUsersSearchCondition>>;
  createOrUpdate: boolean;
  SearchStateSwitch: () => void;
}

const AdminUsersSearchBox: React.FC<props> = (props) => {
  const {
    setMaintenanceDatas,
    Query,
    setQuery,
    createOrUpdate,
    SearchStateSwitch
  } = props;
  const [selectCompare, setSelectCompare] = useState(
    MaintenanceCompareEnum.Equal
  );
  const [crewNumber, setCrewNumber] = useState('');
  const [crewName, setCrewName] = useState('');
  const [crewFurigana, setCrewFurigana] = useState('');
  const [role, setRole] = useState(RoleEnum.Any);
  const [dateCreatedFrom, setDateCreatedFrom] = useState('');
  const [dateCreatedTo, setDateCreatedTo] = useState('');
  const [dateUpdatedFrom, setDateUpdatedFrom] = useState('');
  const [dateUpdatedTo, setDateUpdatedTo] = useState('');

  useEffect(() => {
    setSelectCompare(MaintenanceCompareEnum.Equal);
    setCrewNumber('');
    setCrewName('');
    setCrewFurigana('');
    setRole(RoleEnum.Any);
    setDateCreatedFrom('');
    setDateCreatedTo('');
    setDateUpdatedFrom('');
    setDateUpdatedTo('');
  }, [createOrUpdate]);

  const SerachGetApi = async () => {
    const params = new URLSearchParams();

    if (crewNumber !== '') {
      switch (selectCompare) {
        case MaintenanceCompareEnum.Equal:
          params.append('user_no_eq', crewNumber);
          break;
        case MaintenanceCompareEnum.Greater:
          params.append('user_no_gt', crewNumber);
          break;
        case MaintenanceCompareEnum.Less:
          params.append('user_no_lt', crewNumber);
          break;
      }
    }
    Query.sort.key !== '' &&
      params.append(
        'order',
        Query.sort.key + (Query.sort.sortType ? '_asc' : '_desc')
      );
    crewName !== '' && params.append('name_contains', crewName);
    crewFurigana !== '' && params.append('kana_contains', crewFurigana);
    role !== RoleEnum.Any && params.append('role_eq', role.toString());
    dateCreatedFrom !== '' && params.append('created_at_gte', dateCreatedFrom);
    dateCreatedTo !== '' && params.append('created_at_lt', dateCreatedTo);
    dateUpdatedFrom !== '' && params.append('updated_at_gte', dateUpdatedFrom);
    dateUpdatedTo !== '' && params.append('updated_at_lt', dateUpdatedTo);
    const apiQuery = '/?' + params.toString();

    setQuery((pre) => ({
      ...pre,
      crewNumber: { compare: selectCompare, number: crewNumber },
      crewName: crewName,
      crewFurigana: crewFurigana,
      role: role.toString(),
      dateCreatedFrom: dateCreatedFrom,
      dateCreatedTo: dateCreatedTo,
      dateUpdatedFrom: dateUpdatedFrom,
      dateUpdatedTo: dateUpdatedTo
    }));

    const response = await QueryAdminUsersApi(apiQuery);
    if (response.success) {
      setMaintenanceDatas(response.data as AdminUsersType[]);
      SearchStateSwitch();
    }
  };

  return (
    <>
      <Box
        border='1px'
        borderColor='gray'
        ml={14}
        gridRow='2/3'
        gridColumn='2/2'
        w='80%'
        h='420px'
        bgColor='#f4f4f4'
        fontSize={14}
      >
        <Box bgColor='#e5e6e7'>
          <Text>検索条件</Text>
        </Box>
        <Box w='90%'>
          <Text ml={2} mt={1}>
            乗務員番号
          </Text>
          <HStack>
            <Select
              h='8'
              ml={2}
              value={selectCompare}
              onChange={(e) => setSelectCompare(e.target.value)}
            >
              <option value={MaintenanceCompareEnum.Equal}>等しい</option>
              <option value={MaintenanceCompareEnum.Greater}>より大きい</option>
              <option value={MaintenanceCompareEnum.Less}>より小さい</option>
            </Select>
            <Input
              h='8'
              ml={2}
              bgColor='white'
              value={crewNumber}
              onChange={(e) => setCrewNumber(e.target.value)}
            ></Input>
          </HStack>
          <Text ml={2} mt={1}>
            乗務員名で絞り込む
          </Text>
          <Input
            h='8'
            ml={2}
            bgColor='white'
            value={crewName}
            onChange={(e) => setCrewName(e.target.value)}
          ></Input>
          <Text ml={2} mt={1}>
            フリガナで絞り込む
          </Text>
          <Input
            h='8'
            ml={2}
            bgColor='white'
            value={crewFurigana}
            onChange={(e) => setCrewFurigana(e.target.value)}
          ></Input>
          <Text ml={2} mt={1}>
            管理権限
          </Text>
          <Select
            h='8'
            ml={2}
            value={role}
            onChange={(e) => setRole(Number(e.target.value))}
          >
            <option value={RoleEnum.Any}>任意</option>
            <option value={RoleEnum.MastaMente}>マスタメンテ</option>
            <option value={RoleEnum.Notice}>通知</option>
            <option value={RoleEnum.Browse}>閲覧</option>
            <option value={RoleEnum.Suspension}>利用停止</option>
          </Select>
          <Text ml={2} mt={1}>
            登録日時
          </Text>
          <HStack>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateCreatedFrom}
              onChange={(e) => setDateCreatedFrom(e.target.value)}
            />
            <Text>～</Text>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateCreatedTo}
              onChange={(e) => setDateCreatedTo(e.target.value)}
            />
          </HStack>
          <Text ml={2} mt={1}>
            更新日時
          </Text>
          <HStack>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateUpdatedFrom}
              onChange={(e) => setDateUpdatedFrom(e.target.value)}
            />
            <Text>～</Text>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateUpdatedTo}
              onChange={(e) => setDateUpdatedTo(e.target.value)}
            />
          </HStack>
          <Button
            ml={2}
            mt={2}
            bgColor='gray.800'
            color='white'
            onClick={() => SerachGetApi()}
          >
            絞り込む
          </Button>
        </Box>
      </Box>
    </>
  );
};
export default React.memo(AdminUsersSearchBox);
